// Get count of DR node in a service
export const getDatabaseDRCount = (database) => {
  const dataCentreInstances = database?.instances?.filter((instance) => instance?.type === 'DR');
  return dataCentreInstances?.length || 0;
};
